module.exports = __webpack_public_path__ + "assets/normal/images/weike_avatar_default.b4b81920.png";